import { FETCH_REQUESTS } from "../constants/ActionTypes";
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../constants/pagination';

const INITIAL_STATE = {
  requests: [],
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    per_page: DEFAULT_PER_PAGE,
    total_pages: 0
  }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_REQUESTS:
      // APIv2 returns paginated: { data: [...], page, page_count, total_count }
      return {
        ...state,
        requests: action.payload.data || [],
        isLoading: false,
        pagination: {
          total: action.payload.total_count || 0,
          page: action.payload.page || 1,
          per_page: action.payload.per_page || state.pagination.per_page,
          total_pages: action.payload.page_count || 0
        }
      };
    default:
      return state;
  }
}